import * as React from "react";
import CoffeeComponent from "../components/Coffee/CoffeeComponent";

export default function Coffee() {
  return (
    <main className="min-h-screen pt-24">
      <div className="page-container">
        <h1 className="text-4xl sm:text-5xl font-semibold text-foreground tracking-tight mb-4">
          Coffee
        </h1>
        <p className="text-muted text-lg mb-12 max-w-2xl">
          My journey through specialty coffee - from home brewing to cafe hopping.
        </p>
        <CoffeeComponent />
      </div>
    </main>
  );
}
